/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ue_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encode text for use in URLs and query strings, or decode percent-encoded URLs back to readable text — with full Unicode support, all in your browser.`)
};

const es_ue_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codifica texto para usarlo en URL y cadenas de consulta, o decodifica URL codificadas en porcentaje para devolverlas a texto legible — con soporte completo de Unicode, todo en tu navegador.`)
};

const de_ue_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kodieren Sie Text zur Verwendung in URLs und Query Strings, oder dekodieren Sie mit Prozentzeichen kodierte URLs zurück in lesbaren Text — mit vollständiger Unicode-Unterstützung, alles in Ihrem Browser.`)
};

const nl_ue_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codeer tekst voor gebruik in URL's en querystrings, of decodeer percent-gecodeerde URL's terug naar leesbare tekst — met volledige Unicode-ondersteuning, allemaal in uw browser.`)
};

const fr_ue_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encodez le texte pour utilisation dans les URL et chaînes de requête, ou décodez les URL encodées en pourcentage en texte lisible — avec support Unicode complet, tout dans votre navigateur.`)
};

const it_ue_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codifica il testo per l'uso negli URL e nelle stringhe di query, o decodifica gli URL codificati in percentuale per tornare al testo leggibile — con supporto Unicode completo, tutto nel browser.`)
};

const pt_br2_ue_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codifique texto para uso em URLs e strings de consulta, ou decodifique URLs codificadas por porcentagem para texto legível — com suporte Unicode completo, tudo no seu navegador.`)
};

const pt_ue_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codifique texto para utilização em URLs e strings de consulta, ou descodifique URLs codificados em percentual de volta para texto legível — com suporte completo a Unicode, tudo no seu navegador.`)
};

const ja_ue_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URLとクエリ文字列で使用するためにテキストをエンコードするか、パーセント エンコードされたURLをデコードして読みやすいテキストに戻します。完全なUnicode サポート付きで、すべてブラウザで実行されます。`)
};

const zh_ue_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`对用于 URL 和查询字符串的文本进行编码，或将百分号编码的 URL 解码回可读文本——支持完整的 Unicode，一切都在你的浏览器中完成。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ue_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ue_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ue_intro", locale)
	if (locale === "en") return en_ue_intro(inputs)
	if (locale === "es") return es_ue_intro(inputs)
	if (locale === "de") return de_ue_intro(inputs)
	if (locale === "nl") return nl_ue_intro(inputs)
	if (locale === "fr") return fr_ue_intro(inputs)
	if (locale === "it") return it_ue_intro(inputs)
	if (locale === "pt-BR") return pt_br2_ue_intro(inputs)
	if (locale === "pt") return pt_ue_intro(inputs)
	if (locale === "ja") return ja_ue_intro(inputs)
	return zh_ue_intro(inputs)
};